import React from 'react'
import useApi from 'hooks/useApi'
import { LoadingFull as Loading } from '@arnsbogroup/react-voicearchive'
import ReportRenderer from './components/ReportRenderer'

const DynamicReports = () => {
  const reportId = new URLSearchParams(window.location.search).get('report')
  const [definitions, loading] = useApi('/rest/v2/dynamicreports')

  if (loading || !definitions) return <Loading />

  const report = definitions.find(r => r.id === reportId)

  if (!report) {
    return <div className="py-5 px-6 text-gray-500 text-sm">Report not found: {reportId}</div>
  }

  return (
    <div className="py-3 px-4 lg:py-5 lg:px-6 w-full h-full flex flex-col space-y-4">
      <div className="pb-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">{report.name}</h2>
      </div>
      <div className="flex-1 overflow-auto">
        <ReportRenderer key={report.id} report={report} />
      </div>
    </div>
  )
}

export default DynamicReports
